import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import {Router} from "@angular/router";
import {NotificationsService} from "angular2-notifications";
import {UserService} from "../services/user.service";
import {ReportService} from "../services/report.service";

@Component({
  selector: 'app-referalhistory',
  templateUrl: './referalhistory.component.html',
  styleUrls: ['./referalhistory.component.css']
})
export class ReferalhistoryComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  users = [];
  displayedColumns = ['name','email','referal_user','createdAt'];
  dataSource: MatTableDataSource<any>;
  pageSize = 10;

  permission: String;
  _csrf : null;

  constructor(
    private userService: UserService,
    private router: Router,
    private reportService: ReportService,
    private notif: NotificationsService, ) { }

  ngOnInit() {
     if (!this.userService.isLoggedIn()) {
      this.router.navigateByUrl('/index');
    } else {
      if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
        var spt = this.router.url.split("/");
        var menu_url = spt[1];
        var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
        var adminrules = JSON.parse(localStorage.getItem('adminrules'));
        var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
        if (index != -1) {
          var menuid = adminmenus[index]._id;
          var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
          this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
        }
      }
      this.getreferalhistory();
    }
    this.csrf();
  }

  csrf() {
    this.userService.csrf().subscribe((success) => {
      this._csrf = success._csrf;
   }, (error) => {
      if(error.status>0) {
          this.notif.error(
              'CSRF',
              error.error.message,
              {
                  timeOut: 5000,
                  showProgressBar: true,
                  pauseOnHover: true,
                  clickToClose: true,
                  maxLength: 50
              }
          )
      }
  })
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getreferalhistory(){
    this.reportService.getUserReferals().subscribe((success) => {
      if(success.status){    
        this.dataSource = new MatTableDataSource(success.referal_user);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;      
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/referalhistory/referalhistory.component.ts